import { useCallback, useMemo } from 'react'
import { BrainCircuit } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchMlModels, FRAUD_STR as S, type MlModelRow } from './fraudApi'

/**
 * A25.05 — ML-модели риска. Registry of trained risk models (type, version,
 * AUC, status). Dormant until `/admin/antifraud/models` ships (fail-soft empty).
 * Placeholder permission USERS_VIEW.
 */
export function MlModelsScreen() {
  const columns = useMemo<AdminColumn<MlModelRow>[]>(
    () => [
      { key: 'name', header: S.model, type: 'text' },
      { key: 'kind', header: S.kind, type: 'text' },
      { key: 'version', header: S.version, type: 'text' },
      { key: 'auc', header: S.auc, type: 'number' },
      {
        key: 'status',
        header: S.status,
        type: 'enum',
        options: [
          { value: 'active', label: 'Активна', status: 'active' },
          { value: 'training', label: 'Обучение', status: 'review' },
          { value: 'disabled', label: 'Выключена', status: 'suspended' },
        ],
      },
      { key: 'updated_at', header: S.updated, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetchMlModels, [])
  return (
    <>
      <PageHeader title={S.mlModels} screenId="A25.05" />
      <DataTable<MlModelRow>
        screenId="A25.05"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => r.id}
        exportable
        emptyState={{ icon: <BrainCircuit size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
